import { ProjectFinancialService } from './../../../services/projectFinancial.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Approval } from '../../../models/Approval.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ApprovalService } from '../../../services/approval.service';
import { ConsultantService } from '../../../services/consultant.service';
import { Consultant } from '../../../models/Consultant.model';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { ConsultantSearch } from '../../../models/ConsultantSearch.model';
import { ProjectSearch } from "../../../models/ProjectSearch.model";
import * as _ from "lodash";
import { DropDownList } from '../../../models/DropDownList.model';
import { CompanyService } from "../../../services/billing-letter/company.service";
import { ApprovalsSearchFactory } from '../../../shared/factories/approvals/ApprovalsSearch.factory';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../../shared/auth/Roles';
import { ApprovalBorrowInvoice } from '../../../models/ApprovalBorrowInvoice';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';
import { AccountingPeriodBlockService } from "../../../services/accountingBlock.service";
import { isBlockPeriodInvalid } from '../../../shared/helpers/validate-block-period';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { ContractType } from '../../../shared/enums/ContractType';

@Component({
  selector: 'app-approvals-create',
  templateUrl: './approvals-create.component.html',
  styleUrls: ['./approvals-create.component.scss']
})
export class ApprovalCreateComponent implements OnInit {
  @ViewChild('customerMultiselect') customerMultiselect;
  @ViewChild('projectsMultiselect') projectsMultiselect;
  @ViewChild('consultantMultiselect') consultantMultiselect;

  consultantSearch: ConsultantSearch = new ConsultantSearch();
  approvals: any = [];
  ApprovalsSearchFactory;
  approvalSearchFactory = new ApprovalsSearchFactory();
  approval: Approval = new Approval();
  commonHelper: CommonHelper = new CommonHelper();
  consultants: Consultant[] = new Array<Consultant>();
  companies: Company[] = new Array<Company>();
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  selectedExcellenceCentersItems: any = [];
  allExcellenceCenters: any[] = [];
  selectedCompany;
  consultantSelected: any = [];
  projects: any = [];
  projectsByCompany: any = [];
  currentTotalHours: number = 0;
  currentProjectCustomer: any = null;
  currentDate: Date;
  addProjectCheck = false;
  totalHourValue = 0;
  totalSoldHourValue = 0;
  hourValue: any = 0;
  soldHourValue: any = 0;
  loading: boolean;
  selectedApprovalCompany;
  selectedApprovalCompanyGroup;
  status: number = 0;
  ProjectList: Array<any> = [];
  filteredConsultantList: DropDownList[] = new Array<DropDownList>();
  errorList: Array<any> = [];
  successList: Array<any> = [];
  updatedList: Array<any> = [];
  selectDate: boolean = false;
  date: Date = null;
  competence: number = -1;
  competenceYear: number = -1;
  monthList;
  years;
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  mask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  consultantsBorrowInvoice = [];
  user;

  dropDownListConsultants: Array<DropDownList & {excellenceCenter: string}> = new Array<DropDownList & {excellenceCenter: string}>();
  consultantsFiltered: DropDownList[] = new Array<DropDownList>();
  dropDownListProjects: DropDownList[] = new Array<DropDownList>();
  dropDownListCompanies: DropDownList[] = new Array<DropDownList>();
  dropDownListGroups: DropDownList[] = new Array<DropDownList>();
  dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();

  selectedConsultantsItems: DropDownList[] = new Array<DropDownList>();
  selectedProjectsItems: DropDownList[] = new Array<DropDownList>();
  selectedCompaniesItems: DropDownList[] = new Array<DropDownList>();
  selectedGroupsItems: DropDownList[] = new Array<DropDownList>();

  dropDownGroupsSettings = {};
  dropDownConsultantsSettings = {};
  dropDownExcellenceCentersSettings = {};
  dropDownProjectsSettings = {};
  dropDownCompaniesSettings = {};

  projectExcellenceCentersValid: boolean = false;
  accountingBlock = new AccountingPeriodBlock();

  constructor(
    private approvalService: ApprovalService,
    private consultantService: ConsultantService,
    private companyService: CompanyService,
    private excellenceCentersService: ExcellenceCentersService,
    private projectFinancialService: ProjectFinancialService,
    public toastr: ToastsManager,
    public router: Router,
    private errorHandler: ErrorHandlerProvider,
    private localStorage: LocalStorage,
    private accountingBlockService: AccountingPeriodBlockService
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
        .find(({type}: AccountingPeriodBlock) => type === AccountingType.Approval);

    this.consultantSearch.limit = 99999;
    let consultantSearch = new ConsultantSearch();
    consultantSearch.onlyActives = false;
    consultantSearch.limit = 9999999;

    let projectSearch = new ProjectSearch();
    projectSearch.skip = 0;
    projectSearch.limit = 9999999;

    var response = await this.projectFinancialService.getProjectsAndCustomers();
    consultantSearch.fields = ["_id", "name", 'contract.kind', 'division', 'active', 'excellenceCenter'];

    this.consultants = await this.consultantService.searchConsultants(consultantSearch);
    const allExcellenceCenters = await this.excellenceCentersService.getAll();
    this.allExcellenceCenters = allExcellenceCenters.filter(ec => Number(ec.type) == 1);

    let consultantsPJ = await this.consultantService.listAll();
    consultantsPJ.forEach(c => {
        if(c.sapCardCode != '' && c.contract && c.contract.kind == 1 && c.contract.cnpj != '' && c.contract.sapServiceCode != '')
            this.consultantsBorrowInvoice.push(c);
    });

    this.user = this.localStorage.retrieve('user');
    this.checkPermission();

    this.consultants = _.orderBy(this.consultants, [consultant => consultant.name.toUpperCase()]);

    if (this.user.permission === GUARDS.DP) {
      this.consultants = this.consultants.filter(({contract}) => contract.kind !== ContractType.PJ)
    }

    this.currentDate = new Date();
    this.companies = response.customers;
    this.projects = response.projects;
    this.companyGroups = response.companyGroups;
    this.companyGroups = _.orderBy(this.companyGroups, [companyGroup => companyGroup.name.toUpperCase()]);
    this.projectsByCompany = this.projects;
    this.loading = false;
    this.approval.projects = [];
    this.monthList = this.commonHelper.listAllMonths();
    this.years = this.commonHelper.listLastYears();

    this.dropDownGroupsSettings = this.commonHelper.getDropDownSettings(true, 'Grupos de empresas', false, 'Marcar todos os selecionados', 'Desmarcar todos os selecionados', true, null, '');
    this.dropDownExcellenceCentersSettings = this.commonHelper.getDropDownSettings(true, 'Centros de excelência', false, 'Marcar todos os centros de excelência', 'Desmarcar todos os centros de excelência', true,null,'', false);
    this.dropDownConsultantsSettings = this.commonHelper.getDropDownSettings(false, 'Consultores', false, 'Marcar todos os consultores', 'Desmarcar todos os consultores', true,'active','', true);
    this.dropDownCompaniesSettings = this.commonHelper.getDropDownSettings(true, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true, null, '', true);
    this.dropDownProjectsSettings = this.commonHelper.getDropDownSettings(true, 'Projetos', false, 'Marcar todos os projetos', 'Desmarcar todos os projetos', true, null, '', true);

    this.dropDownListConsultants = this.commonHelper.getDropDownListConsultant(this.consultants, "_id", "name", "contract.kind", 'division', 'active', 'excellenceCenter');
    this.dropDownListCompanies = this.commonHelper.getDropDownListItems(this.companies, "_id", "name");
    this.dropDownListProjects = this.commonHelper.getDropDownListItems(this.projects, "_id", "name");
    this.dropDownListGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
    this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(this.allExcellenceCenters, "_id", "name");
    this.consultantsFiltered = this.dropDownListConsultants;

  }

  checkPermission() {
    let permission = this.user.permission;
    if (permission === GUARDS.MANAGER || (permission === GUARDS.GOVERNANCE && !this.user.isGovernanceMaster) ) {
      if(this.user.excellenceCenters)
        this.allExcellenceCenters = this.allExcellenceCenters.filter(ec=>{
          return this.user.excellenceCenters.find(uec => uec._id == ec._id)})
    }
  }

  addProject() {
    let project = {
      customer: { financialId: null, financialName: null },
      projectFinancialId: null,
      name: null,
      total_hours: null,
      excellenceCenter: {_id:'', name:''},
      excellenceCenterList: []
    };

    project.customer.financialId = this.selectedApprovalCompany[0]._id;
    project.customer.financialName = this.selectedApprovalCompany[0].name;
    project.projectFinancialId = this.currentProjectCustomer[0]._id;
    project.name = this.currentProjectCustomer[0].name;
    project.total_hours = this.currentTotalHours;

    const excellenceCenterList = [...this.currentProjectCustomer[0].excellenceCenters];
    project.excellenceCenterList = excellenceCenterList;
    if(project.excellenceCenterList.length == 1) {
        project.excellenceCenter = {
            _id: project.excellenceCenterList[0]._id,
            name: project.excellenceCenterList[0].name
        }
    }

    this.ProjectList.push(project);
    this.validProjectExcellenceCenters();

    this.currentTotalHours = 0;
    this.selectedGroupsItems = null;
    this.selectedCompany = null;
    this.currentProjectCustomer = null;
    this.selectedProjectsItems = null;
    this.customerMultiselect.settings.disabled = true;
    this.projectsMultiselect.settings.disabled = true;
  }

  selectAll(event: any) {
    let element: any = document.querySelector('.c-input.ng-valid.ng-dirty.ng-touched')
    if (element != null && element.value) {
      let value = element.value;
      this.filterConsultantsByContract(value);
    }
  }

  async createNewApproval() {
    try {
      this.loading = true;
      if(this.competence >= 0 && this.competenceYear != -1) {
        const isInvalid = isBlockPeriodInvalid({
            competence: this.competence, competenceYear: this.competenceYear
        }, this.accountingBlock, true);
        if (isInvalid) {
            this.loading = false;
            return this.toastr.warning(`A competência
            ${(this.monthList.find((m: {number: number, name: string}) => Number(m.number) === Number(this.competence))).name.toLowerCase()}/${this.competenceYear},
                está dentro do intervalo de bloqueio. Por favor selecione
                uma data diferente antes de salvar a aprovação.`, 'Bloqueio Contábil', {
            toastLife:8000,
            showCloseButton: true
            });
        }
        this.approvals.forEach(approval => {
          let dateAux = new Date();
          dateAux.setDate(1);
          dateAux.setMonth(this.competence);
          dateAux.setFullYear(this.competenceYear);
          approval.date = dateAux.toISOString();
          approval.dateEdited = true;
        });
      }
      this.clearLists();
      for (let approval of this.approvals) {
        approval.approvedHours = approval.realizedHours;
        approval.status = this.status;
      };

      if(this.approvals.length) {
        let consultantValid = true;
        this.approvals.forEach(approval => {
          const consultantPJWithouCNPJ = approval.consultant && approval.consultant.contract &&
          approval.consultant.contract.kind == 1 && (!approval.consultant.contract.cnpj || approval.consultant.contract.cnpj == "");
          if(consultantPJWithouCNPJ && approval.status != 5 && (!approval.borrowedInvoice || !approval.borrowedInvoice._id)) {
            this.toastr.warning(`O consultor ${approval.consultant.name} não possui CNPJ`);
            consultantValid = false;
          }

          const projectWithoutExcellenceCenter = approval.project && (!approval.project.excellenceCenter._id || approval.project.excellenceCenter._id == "");
          if(projectWithoutExcellenceCenter){
            this.toastr.warning(`O projeto ${approval.project.name} não possui Centro de Excelência`);
            consultantValid = false;
          }
        });

        if(!consultantValid) {
          this.loading = false;
          return;
        }
      }
      let responses = await this.approvalService.create(this.approvals);
      if(responses && responses.length > 0){
        const statusResponse = responses[0].status;
        if(statusResponse == 400 || statusResponse == 500){
          this.resetApprovalForm();
          this.errorHandler.interceptError(responses[0], 'Aprovação');
        } else {
          this.approvals = responses;
        }
      }

      this.loading = false;
      this.getReturnLists(responses);
    } catch (err) {
      this.errorHandler.interceptError(err, 'Aprovação');
    }

  }

  resetApprovalForm() {
    this.clearLists();
    this.approvals = [];
    this.competence = -1;
    this.competenceYear = -1;
    this.status = 0;
  }

  deleteProject(i: number) {
    this.ProjectList.splice(i, 1);
    this.onProjectChange()
  }

  changeExcellenceCenter(){
    this.consultantsFiltered = [];
    if(this.selectedExcellenceCentersItems.length > 0){
      this.consultantsFiltered = _.filter(this.dropDownListConsultants, item => {
        return item.excellenceCenter == this.selectedExcellenceCentersItems[0].id;
      });
      this.consultantMultiselect.settings.disabled = false;
    } else {
      this.consultantMultiselect.settings.disabled = true;
    }
  }

  changeSelectExcellenceCenter(index, centerId){
    let selectedExcelenceCenter = this.ProjectList[index].excellenceCenterList.find(p => p._id == centerId)
    if(selectedExcelenceCenter) {
        this.ProjectList[index].excellenceCenter = {
            _id: selectedExcelenceCenter._id,
            name: selectedExcelenceCenter.name
        }
    }
    this.validProjectExcellenceCenters();
  }

  validProjectExcellenceCenters() {
    const projectInvalids = this.ProjectList.filter(project => !project.excellenceCenter._id);
    if(this.ProjectList.length == 0 || projectInvalids.length > 0) {
      this.dropDownExcellenceCentersSettings = { ...this.dropDownExcellenceCentersSettings, disabled: true };
      this.projectExcellenceCentersValid = false;
    } else {
      this.dropDownExcellenceCentersSettings = { ...this.dropDownExcellenceCentersSettings, disabled: false };
      this.projectExcellenceCentersValid = true;
    }
  }

  getReturnLists(responses) {
    this.errorList = _.filter(responses, { success: false });
    this.successList = _.filter(responses, { success: true, updated: false });
    this.updatedList = _.filter(responses, { updated: true });
  }

  clearLists() {
    this.errorList = [];
    this.successList = [];
    this.updatedList = [];
  }

  removeSuccess() {
    _.remove(this.approvals, (approval) => { return (approval.updated == false && approval.success == true) });
    this.successList = [];
  }

  removeUpdated() {
    _.remove(this.approvals, (approval) => approval.updated == true);
    this.updatedList = [];
  }

  async search() {
    this.loading = true;
    let reminder = false;
    let approvals = [];
    let ids = [];
    if (this.consultantSelected.length > 0) {
      for (let item of this.consultantSelected) {
        ids.push(item.id);
      }

      this.consultantSearch._id = ids;
      let consultants = await this.consultantService.searchConsultants(this.consultantSearch);
      for (let consultant of consultants) {
        let approval = new Approval();
        approval.consultant.loadToApproval(consultant);
        approval.projects = _.cloneDeep(this.ProjectList);
        approval['success'] = null;
        approval['updated'] = false;
        approvals.push(approval);

        if(consultant.contract.kind == 1 && consultant.contract.honorarium == 2)
            reminder = true;
      }
      this.approvals = approvals;

      this.onProjectChange();
      this.selectedExcellenceCentersItems = [];
    }

    if(reminder)
        this.toastr.info("Utilize as opções 'HORAS EXTRAS' ou 'DESCONTAR HORAS' quando o valor total da aprovação for diferente do valor de contrato do consultor",'Lembrete');

    this.loading = false;
  }

  OnCancel() {
    this.selectedCompany = null;
    this.consultantSelected = null;
    this.selectedExcellenceCentersItems = null;
    this.ProjectList = [];
    this.currentTotalHours = 0;
    this.currentProjectCustomer = null;
    this.hourValue = 0;
    this.soldHourValue = 0;
    this.totalHourValue = 0;
    this.totalSoldHourValue = 0;
    this.approvals = [];
    this.competence = -1;
    this.competenceYear = -1;
    this.selectedProjectsItems = new Array<DropDownList>();
    this.selectedGroupsItems = null;
    this.clearLists();
  }

  removeApproval(id) {
    _.remove(this.approvals, (approval) => {
      return approval.consultant._id == id;
    });
  }

  onProjectChange() {

    for (let approval of this.approvals) {
      approval.realizedHours = 0;
      approval.totalHourValue = 0;
      approval.totalSoldHourValue = 0;
      approval.projects.map(item => {
        approval.realizedHours += item.total_hours;
        item.approvedHours = item.total_hours;
        item.approvedValue = this.valueCheck(item.total_hours * approval.consultant.contract.hourValue, approval.consultant.contract.totalValue.valueOf()) ? approval.consultant.contract.totalValue.valueOf() : item.total_hours * approval.consultant.contract.hourValue;
        approval.totalHourValue = approval.consultant.contract.hourValue.valueOf() * approval.realizedHours;
        approval.totalValue = this.valueCheck(approval.totalHourValue, approval.consultant.contract.totalValue.valueOf()) ? approval.consultant.contract.totalValue.valueOf() : approval.totalHourValue;
        approval.totalSoldHourValue = approval.consultant.contract.soldHourValue ? approval.consultant.contract.soldHourValue.valueOf() * approval.realizedHours : 0;
      });
    }

  }

  clear() {
    this.consultantSelected = [];
    this.approvals = [];
  }

  async changeCompanyGroup() {
    this.selectedCompany = null;
    this.selectedProjectsItems = null;
    if (this.selectedGroupsItems.length > 0) {
        const companiesByGroupId = await this.companyService.getCompaniesByGroupId(this.selectedGroupsItems[0].id);
        this.dropDownListCompanies = this.commonHelper.getDropDownListItems(companiesByGroupId, "_id", "name");
        this.customerMultiselect.settings.disabled = false;
    } else {
        this.customerMultiselect.settings.disabled = true;
        this.projectsMultiselect.settings.disabled = true;
    }
  }

  changeCustomer() {
    if (this.selectedCompany.length > 0) {
      this.selectedApprovalCompany = _.filter(this.companies, { _id: this.selectedCompany[0].id });
      this.dropDownListProjects = this.commonHelper.getDropDownListItems(this.projects.filter(x => x.companyId == this.selectedCompany[0].id), "_id", "name");
      this.projectsMultiselect.settings.disabled = false;
    } else {
        this.projectsMultiselect.settings.disabled = true;
    }
  }

  changeProject() {
    if (this.selectedProjectsItems.length > 0) {
      this.currentProjectCustomer = _.filter(this.projects, { _id: this.selectedProjectsItems[0].id });
    }
  }

  valueCheck(projectHours, totalValue) {
    if (Math.abs(projectHours - totalValue) <= 1) {
      return true;
    }
    return false;
  }

  filterConsultantsByContract(value) {
    switch (value.toUpperCase()) {
      case 'PJ':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'PJ';
        });
        break;
      case 'CLT':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'CLT';
        });
        break;
      case 'OUTROS':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'Outros';
        });
        break;
      case 'ESTAGIÁRIO':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'Estagiário';
        });
        break;

      default:
        return
    }

  }

//   filterByDivision() {
//     if (this.selectedDivisionsItems.length > 0) {
//       this.consultantsFiltered = _.filter(this.dropDownListConsultants, item => {
//         return item.division == this.selectedDivisionsItems[0].itemName;
//       });
//       this.consultantMultiselect.settings.disabled = false;
//     }

//   }

  verifyDate(date) {
    if (!(new RegExp(this.datePattern).test(date))) {
      this.toastr.warning(`Digite uma data válida.`, "Data inválida!");
      this.date = null;
    }
  }

  get verifyNullDate() {
    return (this.date && this.selectDate)
  }

  getApprovalData(borrowedInvoiceData: ApprovalBorrowInvoice) {
    this.approval.borrowedInvoice = Object.assign({}, borrowedInvoiceData);
  };
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/approvals-create/approvals-create.component.ts